var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircledExclamationMark = function SvgCircledExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    stroke: "#EC4D3D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC4D3D",
    d: "M22.012 27.309c.62 0 1.043-.41 1.054-1.043l.106-13.653c0-.668-.54-1.125-1.172-1.125-.633 0-1.172.457-1.172 1.125l.129 13.653c.012.632.434 1.043 1.055 1.043M22 33.766c.926 0 1.664-.75 1.664-1.664 0-.926-.738-1.664-1.664-1.664a1.663 1.663 0 1 0 0 3.328"
  })));
};
export default SvgCircledExclamationMark;